import { render, staticRenderFns } from "./print-detail-list.vue?vue&type=template&id=5b0f9142&scoped=true"
import script from "./print-detail-list.vue?vue&type=script&setup=true&lang=js"
export * from "./print-detail-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./print-detail-list.vue?vue&type=style&index=0&id=5b0f9142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f9142",
  null
  
)

export default component.exports